import { createSelector } from 'reselect'

const formatAddress = address => {
  const [street, floor] = address.street.split('\n')

  return {
    ...address,
    floor,
    street,
    label: `${address.street}, ${address.city}, ${address.region}`,
    value: address.postcode
  }
}

export const getAddresses = createSelector(
  state => state.user.addresses.data,
  addresses => addresses.map(formatAddress)
)

export const addressesLoading = createSelector(
  state => state.user.addresses.loading,
  loading => loading
)

export const addressesCached = createSelector(
  state => state.user.addresses.succeed,
  succeed => succeed
)

export const getCards = createSelector(
  state => state.user.cards.data,
  cards => cards
)

export const cardsLoading = createSelector(
  state => state.user.cards.loading,
  loading => loading
)

export const cardsCached = createSelector(
  state => state.user.cards.succeed,
  succeed => succeed
)

export const getUserInfo = createSelector(
  state => state.user.userInfo.data,
  userInfo => userInfo
)

export const getUserInitials = createSelector(
  state => state.user.userInfo.data,
  userInfo => {
    if (userInfo) {
      const { firstname, lastname } = userInfo

      return [
        ...(firstname ? [firstname.trim()[0]] : ['']),
        ...(lastname ? [lastname.trim()[0]] : [''])
      ]
        .join('')
        .trim()
    }
  }
)



// WEBPACK FOOTER //
// ./src/selectors/user.js